import gql from "graphql-tag";

export const animalWithTag = gql`
  fragment animalWithTag on Animal {
    id
    dateMovedToFarm
    dob
    eId
    passportNumber
    isMale
    sexClassification {
      slug
      title
    }
    dateLeftFarm
    visualId
    deadAt
    field {
      id
      name
    }
    group {
      id
      name
    }
    animalBreeds {
      id
      name
      breedrCode
      newClassification
    }
    tags {
      tagId
      name
      color
      schema {
        ownership
      }
    }
  }
`;
